export function getRouteProps(route) {
  const { childRoutes, indexRoute, component, onEnter, ...props } = route; // NOSONAR
  return props;
}

export function getRoutesProps(routesArray) {
  return routesArray.reduce((accumulator, route) => ({
    ...accumulator,
    ...getRouteProps(route),
  }), {});
}

export function getRoutesProp(routesArray, name, defaultValue) {
  const prop = getRoutesProps(routesArray)[name];
  if (prop === undefined) {
    return defaultValue;
  }
  return prop;
}

export function getRoutesPropDepth(routesArray, name) {
  return routesArray.reduce((accumulator, route, idx) => {
    if (getRouteProps(route)[name] !== undefined) return idx;
    else return accumulator;
  }, -1);
}

export function getPropFromRoutePath(routesArray, name) {
  return routesArray
    .map(route => getRouteProps(route)[name])
    .reduce((acc, prop) => (prop ? acc.concat(prop) : acc), [])
    .filter((el, index, arr) => index === arr.indexOf(el)); // UNIQUE
}
